import React, { useEffect } from "react";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../common_components/common_widgets/popup";
import { TOGGLE_AUDIT_GROUP_PROCESS_MANAGER_WARNING_POPUP } from "./reducers/audit-properties-reducer";
import MdaeButton from "../../common_components/common_widgets/button";
import { useDispatch, useSelector } from "react-redux";
import { isEqual } from "lodash";

export const toggleAuditGroupProcessManagerWarningPopup = (isVisible, dispatch) => {
  dispatch({
    type: TOGGLE_AUDIT_GROUP_PROCESS_MANAGER_WARNING_POPUP,
    data: {
      isAuditGroupProcessManagerWarningPopupVisible: isVisible
    },
  });
}


const AuditGroupProcessManagerWarningPopup: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const processManagerId = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData.processManagerId,
    isEqual
  );

  const allProcessManagersList = useSelector(
    (state) => state["auditPropertiesReducer"].allProcessManagersList,
    isEqual
  );

  const getManagerName = () => {
    if (processManagerId) {
      let filteredItem = allProcessManagersList?.filter(x => x.auditUserId === processManagerId)
      return filteredItem && filteredItem[0]?.fullName;
    }
  }
  const getPopupTitle = () => {
    return (
      <MdaePopupTitle
        isSmallPopup
        closePopupHandler={() => {
          props.onAuditGroupProcessManagerWarningCancelClick();
          toggleAuditGroupProcessManagerWarningPopup(false, dispatch);
        }}
      >
        Warning
      </MdaePopupTitle>
    );
  };
  return (
    <div>
      <MdaePopup
        deferRendering={false}
        width={400}
        height={200}
        className="-warning-popup"
        mdaeTitleRender={getPopupTitle}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_AUDIT_GROUP_PROCESS_MANAGER_WARNING_POPUP,
            reducerName: "auditPropertiesReducer",
            widgetOptionBindings: {
              visible: "isAuditGroupProcessManagerWarningPopupVisible",
            },
          },
        ]}
        mdaeContentRender={() => {
          return (
            <MdaePopupContent>
              <div className="message-section">
                The current process manager {getManagerName()} is not linked to the new Audit Group and a different user will need to be assigned. Do you want to continue?
              </div>
            </MdaePopupContent>
          )
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"pnlNotificationDateWarningPopupSecondaryButton"}
                  role={"secondary"}
                  onClick={() => {
                    props.onAuditGroupProcessManagerWarningCancelClick();
                    toggleAuditGroupProcessManagerWarningPopup(false, dispatch);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"pnlNotificationDateWarningPopupPrimaryButton"}
                  role={"primary"}
                  onClick={() => {
                    props.onAuditGroupProcessManagerWarningOkClick();
                    toggleAuditGroupProcessManagerWarningPopup(false, dispatch);
                  }}
                >
                  Ok
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          )
        }}
      >

      </MdaePopup>
    </div>
  )

}

export default AuditGroupProcessManagerWarningPopup;